import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Alert, Box, Chip, CircularProgress, Typography } from "@mui/material";

const HistoricoAltas = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);

  const toBool = (v) => {
    if (v === null || v === undefined) return false;
    if (typeof v === "boolean") return v;
    if (typeof v === "number") return v !== 0;
    const s = String(v).toLowerCase();
    return s === "1" || s === "true" || s === "si";
  };

  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        const response = await fetch("/bbdd.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ query: "SELECT * FROM usuarios" }),
        });

        const data = await response.json();

        if (data.success) {

          const rows = data.data.map((row) => {
            const numPant =
              row.num_pantallas !== null &&
              row.num_pantallas !== undefined &&
              row.num_pantallas !== ""
                ? Number(row.num_pantallas)
                : null;

            return {
              ...row,
              id: Number(row.id),
              ordenador: toBool(row.ordenador),
              pantallas: toBool(row.pantallas) || (!!numPant && numPant > 0),
              num_pantallas: numPant,
              movil: toBool(row.movil),
              acceso_servidor: toBool(row.acceso_servidor),
              office: toBool(row.office),
              abbantia: toBool(row.abbantia),
              acceso_remoto: toBool(row.acceso_remoto),
              app_interna: toBool(row.app_interna),
              usuario_abbantia: toBool(row.usuario_abbantia),
              pin_portero: toBool(row.pin_portero),
            };
          });

          setUsuarios(rows);
        } else {
          console.error("Error al obtener datos:", data.message);
        }
      } catch (err) {
        console.error("Error en la solicitud:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsuarios();
  }, []);

  const booleanChip = (value) => (
    <Chip label={toBool(value) ? "Si" : "No"} color={toBool(value) ? "success" : "error"} />
  );

  const textCell = (params) => (
    <Box sx={{ whiteSpace: "normal", overflowWrap: "break-word" }}>{
      params.value || "-"
    }</Box>
  );

  const booleanColumn = (field, headerName, width = 120) => ({
    field,
    headerName,
    width,
    renderCell: (params) => booleanChip(params.row?.[field]),
    sortable: true,
  });

  const columns = [
    { field: "id", headerName: "ID", width: 70, sortable: true },
    { field: "apellidos", headerName: "Apellidos", width: 150, sortable: true },
    { field: "nombre", headerName: "Nombre", width: 150, sortable: true },
    { field: "departamento", headerName: "Departamento", width: 150, sortable: true },
    { field: "fecha_alta", headerName: "Fecha Alta", width: 130, sortable: true },
    { field: "fecha_baja", headerName: "Fecha Baja", width: 130, sortable: true },
    { field: "email", headerName: "Email", width: 200, sortable: true },
    { field: "telefono", headerName: "Telefono", width: 130, sortable: true },
    booleanColumn("ordenador", "Ordenador"),
    booleanColumn("pantallas", "Pantallas"),
    { field: "num_pantallas", headerName: "Num. Pantallas", width: 120, sortable: true },
    booleanColumn("movil", "Movil"),
    {
      field: "otro_hardware",
      headerName: "Otro Hardware",
      width: 250,
      renderCell: textCell,
      valueGetter: (params) => params.row?.otro_hardware ?? "",
      sortable: true,
    },
    booleanColumn("acceso_servidor", "Acceso Servidor", 150),
    booleanColumn("office", "Office", 100),
    booleanColumn("abbantia", "Abbantia", 120),
    booleanColumn("acceso_remoto", "Acceso Remoto", 150),
    booleanColumn("app_interna", "App Interna", 120),
    {
      field: "observaciones",
      headerName: "Observaciones",
      width: 250,
      renderCell: textCell,
      valueGetter: (params) => params.row?.observaciones ?? "",
      sortable: true,
    },
    booleanColumn("usuario_abbantia", "Usuario Abbantia", 150),
    booleanColumn("pin_portero", "PIN Portero", 120),
    { field: "firmado_por", headerName: "Firmado por", width: 200, sortable: true },
    { field: "fecha_firma", headerName: "Fecha Firma", width: 130, sortable: true },
  ];

  return (
    <Box sx={{ width: "95%", padding: 2 }}>
      <Typography variant="h5" sx={{ marginBottom: 2 }}>
        Historico de Altas
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : usuarios.length === 0 ? (
        <Alert severity="warning">No hay registros en el historial de altas.</Alert>
      ) : (
        <Box sx={{ width: "100%", overflowX: "auto" }}>
          <DataGrid
            autoHeight
            rows={usuarios}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 20, 50]}
            initialState={{
              sorting: { sortModel: [{ field: "id", sort: "desc" }] },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default HistoricoAltas;
